import React from 'react';
import type { IconProps } from '@models/types';
import { styled } from '@mui/material/styles';

const Icon: React.FC<IconProps> = (props) => (
    <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M17.5 20H19.5C19.7652 20 20.0196 19.8946 20.2071 19.7071C20.3946 19.5196 20.5 19.2652 20.5 19V3C20.5 2.73478 20.3946 2.48043 20.2071 2.29289C20.0196 2.10536 19.7652 2 19.5 2H9.5C9.23478 2 8.98043 2.10536 8.79289 2.29289C8.60536 2.48043 8.5 2.73478 8.5 3V5'
            stroke='black'
            strokeWidth='2'
            strokeLinecap='round'
        />
        <path
            d='M17.5 6V21C17.5 21.5523 17.0523 22 16.5 22H4.5C3.94771 22 3.5 21.5523 3.5 21L3.5 6C3.5 5.44772 3.94771 5 4.5 5H16.5C17.0523 5 17.5 5.44772 17.5 6Z'
            stroke='black'
            strokeWidth='2'
        />
        <path
            d='M10.5 17.5C8.29086 17.5 6.5 15.7091 6.5 13.5C6.5 11.2909 8.29086 9.5 10.5 9.5C12.7091 9.5 14.5 11.2909 14.5 13.5C14.5 15.7091 12.7091 17.5 10.5 17.5Z'
            stroke='black'
            strokeWidth='2'
        />
        <path
            d='M7 14.0339C7 14.0339 9.07708 13.822 10.4618 14.4576C11.8472 15.0932 12.2612 16.6199 11.8465 17'
            stroke='black'
            strokeWidth='2'
            strokeLinecap='round'
        />
        <path d='M10 10C10 10 10 12 11.5 12' stroke='black' strokeWidth='2' strokeLinecap='round' />
    </svg>
);

export const InternationalIcon = styled(Icon)({});
